module.exports = __webpack_public_path__ + "static/ls2-logo-d80fb7a8341cef24ff6048c94bf2f619.png";